// extracted by mini-css-extract-plugin
export var arrow = "UploadDocumentsModal-module--arrow--a6ff2";
export var arrowNo = "UploadDocumentsModal-module--arrow_no--a2abb";
export var arrowYes = "UploadDocumentsModal-module--arrow_yes--529c0";
export var checkbox = "UploadDocumentsModal-module--checkbox--8f864";
export var checkboxDescription = "UploadDocumentsModal-module--checkboxDescription--e6658";
export var description = "UploadDocumentsModal-module--description--59cc5";
export var flex = "UploadDocumentsModal-module--flex--55dcd";
export var flex1 = "UploadDocumentsModal-module--flex_1--fd96d";
export var flexCenter = "UploadDocumentsModal-module--flex_center--f5baf";
export var flexCenterCol = "UploadDocumentsModal-module--flex_center_col--cc433";
export var flexCol = "UploadDocumentsModal-module--flex_col--14680";
export var flexFixCenterCol = "UploadDocumentsModal-module--flex_fix_center_col--68adb";
export var flexFixedCenterCol = "UploadDocumentsModal-module--flex_fixed_center_col--654ca";
export var inputRow = "UploadDocumentsModal-module--inputRow--ceb07";
export var padding = "UploadDocumentsModal-module--padding--4eedb";
export var policy = "UploadDocumentsModal-module--policy--2d434";
export var rotating = "UploadDocumentsModal-module--rotating--00445";
export var sectionTitle = "UploadDocumentsModal-module--sectionTitle--112fd";
export var sectionTitleDescription = "UploadDocumentsModal-module--sectionTitleDescription--2bab0";
export var submitButton = "UploadDocumentsModal-module--submitButton--2e769";
export var title = "UploadDocumentsModal-module--title--89aa7";